const apiUrl = process.env.REACT_APP_PLANO_TIPO_PDF_LAMBDA_API_URL;
const apiKey = process.env.REACT_APP_CLIENT_APIKEY;

const setHeaders = () => {
  let myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("X-Api-Key", apiKey);
  return myHeaders;
};

export async function fetch_projectList(clientId) {
  try {
    const requestOptions = {
      method: "GET",
      headers: setHeaders(),
      // body: myMetric,
    };

    const response = await fetch(
      `${apiUrl}/proyectos/${clientId}`,
      requestOptions
    );
    const json = await response.json();
    // console.log("fetch_projectList", json);

    if (json?.data) return json.data;
    throw json;
  } catch (error) {
    console.trace("CATCH fetch_projectList:", error);
    return {
      message: "Error solicitando listado de proyectos",
      error,
    };
  }
}

export async function fetch_inventory(clientId, projectId, spreadSheetName) {
  try {
    const requestOptions = {
      method: "GET",
      headers: setHeaders(),
      // body: myMetric,
    };

    const spreadsheetQueryParam = spreadSheetName
      ? `&spreadsheetName=${spreadSheetName}`
      : "";

    const response = await fetch(
      `${apiUrl}/inventory/${clientId}?proyecto=${projectId}${spreadsheetQueryParam}`,
      requestOptions
    );
    const json = await response.json();
    // console.log("fetch_inventory", json);

    if (json?.data) return json.data;
    throw json;
  } catch (error) {
    console.trace("CATCH fetch_inventory:", error);
    return {
      message: `Error solicitando inventario para el proyecto ${projectId}`,
      error,
    };
  }
}

export async function fetch_pdf(clientId, body, signal) {
  try {
    const requestOptions = {
      method: "POST",
      headers: setHeaders(),
      body: JSON.stringify(body),
      signal,
    };

    const response = await fetch(`${apiUrl}/${clientId}`, requestOptions);
    const json = await response.json();
    // console.log("fetch_pdf", json);

    if (json?.data) return json.data;
    throw json;
  } catch (error) {
    if (error.name !== "AbortError") {
      console.trace("CATCH fetch_pdf:", error);
      return {
        message: `Error solicitando el PDF para el proyecto ${body.proyecto} | unidad ${body.unidad}`,
        error,
      };
    } else {
      return null;
    }
  }
}
